import { SizeClass, useSizeClass } from '@omni/kit/contexts/SizeClassContext';
import { useEffect, useState } from 'react';
import { Platform } from 'react-native';
import { useLocation } from 'react-router-dom';

/**
 * Hook to get the value of `?take_attendance=true` from the URL on web.
 * Reacts to query changes.
 */
export const useTakeAttendanceQuery = (): boolean => {
  const { sizeClass } = useSizeClass();
  const isSmall = sizeClass === SizeClass.Small;
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const location = Platform.OS === 'web' && !isSmall ? useLocation() : null;
  const [takeAttendance, setTakeAttendance] = useState(false);

  useEffect(() => {
    if (Platform.OS === 'web' && location) {
      const searchParams = new URLSearchParams(location.search);
      setTakeAttendance(searchParams.get('take_attendance') === 'true');
    }
  }, [location, location?.search]);

  return takeAttendance;
};
